import style from "./ApiHeader.module.scss";
import Advantages from "./advantages";

export default function ApiHeader({ openModal, dictionary }) {
	return (
		<section className={style.header}>
			<h1
				className={style.title}
				dangerouslySetInnerHTML={{
					__html: dictionary["explore_all_advantages_of _generative_ai"]?.replace("Bgrem.ai", "<span>Bgrem.ai</span>") || `Explore all advantages of \ngenerative AI with <span>Bgrem.ai</span> API`,
				}}
			/>

			<Advantages {...{ dictionary }} />
			<button onClick={openModal} className={style.button}>
				{dictionary["request_a_demo"] || "Request a demo"}
			</button>
		</section>
	);
}
